var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueDiamondNoborder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.769 9.18908L14.7896 4.8056C14.5926 4.69924 14.3553 4.69924 14.1582 4.8056L6.17888 9.18908C5.96625 9.30542 5.8338 9.52829 5.83325 9.77067V18.9564C5.83329 19.0757 5.86543 19.1928 5.92631 19.2954C5.98698 19.3976 6.07428 19.4814 6.17888 19.538L14.1582 23.9214C14.3553 24.0278 14.5926 24.0278 14.7896 23.9214L22.769 19.538C22.8736 19.4814 22.9609 19.3976 23.0216 19.2954C23.0824 19.1928 23.1146 19.0757 23.1146 18.9564V9.77067C23.1141 9.52829 22.9816 9.30542 22.769 9.18908Z",
    fill: "#1933A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4739 7.052L8.82426 17.6867L5.83325 9.77049C5.8338 9.52811 5.96625 9.30525 6.17888 9.18891L14.4739 7.052Z",
    fill: "#2E4AC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.474 4.72559V7.05193L6.17896 9.18884L14.1583 4.80536C14.2551 4.75262 14.3637 4.72518 14.474 4.72559Z",
    fill: "#3452D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7689 9.18884L14.4739 7.05193V4.72559C14.5842 4.72518 14.6927 4.75262 14.7896 4.80536L22.7689 9.18884Z",
    fill: "#355AEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1146 9.77049L20.1236 17.6867L14.4739 7.052L22.7689 9.18891C22.9816 9.30525 23.114 9.52811 23.1146 9.77049Z",
    fill: "#264BE0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82426 17.6867L5.92631 19.2952C5.86543 19.1926 5.83329 19.0755 5.83325 18.9562V9.77051L8.82426 17.6867Z",
    fill: "#1C3BBE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1145 9.77051V18.9562C23.1145 19.0755 23.0824 19.1926 23.0215 19.2952L20.1235 17.6867L23.1145 9.77051Z",
    fill: "#2442BF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1236 17.6867H8.82422L14.4739 7.052L20.1236 17.6867Z",
    fill: "#355AEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1236 17.6866L14.4739 24.001L8.82422 17.6866H20.1236Z",
    fill: "#2E4AC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDiamondNoborder);
export default __webpack_public_path__ + "static/media/blue_diamond_noborder.c05944b5.svg";
export { ForwardRef as ReactComponent };